module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "210%",
      "margin-top": "10%"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ack#toc1a",
      "id": "toc1"
    }
  }, [_vm._v("     Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/introduction#toc2a",
      "id": "toc2"
    }
  }, [_vm._v("     Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch01#toc3a",
      "id": "toc3"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("   How Real Are the Elementary Particles?")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch02#toc4a",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("   The Emergence of Complexity; and an Interview with Matthieu Ricard")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch03#toc5a",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("   Toward the Complexity of Life")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#toc6a",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("   How Life Unfolds; and an Interview with Richard Gere")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#toc7a",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("   The Magic of the Human Genome and Its Ethical Problems; and an Interview with His Holiness the Karmapa")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#toc8a",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("   From Consciousness to Ethics")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch07#toc9a",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("   Last Words")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/about#toc10a",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Mind and Life Institute")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/notes#toc11a",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/index#toc12a",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0